<app-wizard-modal [isLoading]="isLoading" (stepChange)="onStepChange($event)" (cancel)="onWizardCancel()"
                  (submit)="onWizardSubmit()">
    <app-wizard-title>{{ 'admin.tools.form.configTitle' | translate }}</app-wizard-title>

    <app-wizard-step>
        <ng-template #title>{{ 'admin.tools.form.sections.line' | translate }}</ng-template>
        <ng-template #content>
            <app-alert class="info-msg"
                       [responsive]="true"
                       type="warning"
                       [message]="
                        (!isToolInLiftAndStanceNull
                        ? ('admin.tools.form.informText.lineDisabled' | translate)
                        : ('admin.tools.form.informText.line' | translate))">
            </app-alert>
            <app-tool-main-line-form *ngIf="tool"
                                     [lines]="availableLines"
                                     [selectedLine]="tool.selectedMainLine"
                                     [disabled]="!isToolInLiftAndStanceNull">
            </app-tool-main-line-form>
        </ng-template>
    </app-wizard-step>

    <app-wizard-step>
        <ng-template #title>{{ 'admin.tools.form.sections.parts' | translate }}</ng-template>
        <ng-template #content>
            <app-alert class="info-msg"
                       [responsive]="true"
                       type="warning"
                       message="{{'admin.tools.form.informText.partNumber' | translate}}"></app-alert>
            <app-tool-part-numbers-form *ngIf="tool"
                                        [availableParts]="availableParts"
                                        [selectedPartNumbers]="tool.partNumbers">
            </app-tool-part-numbers-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canSave]="!showSPI">
        <ng-template #title>{{ 'admin.tools.form.sections.equipments' | translate }}</ng-template>
        <ng-template #content>
            <app-alert class="info-msg"
                       [responsive]="true"
                       type="warning"
                       [message]="'admin.tools.form.informText.equipment' | translate">
            </app-alert>
            <app-tool-main-equipment-form *ngIf="tool" [availableMainEquipments]="availableMainEquipments"
                                          [selectedMainEquipments]="tool.mainEquipment">
            </app-tool-main-equipment-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step *ngIf="showSPI">
        <ng-template #title>{{ 'admin.tools.form.sections.insertionCycles' | translate }}</ng-template>
        <ng-template #content>
            <app-tool-insertion-cycles-form *ngIf="tool"
                                            [availableInsertionCycles]="availableInsertionCycles"
                                            [selectedInsertionCycles]="tool.insertionCycles"
                                            [isSPI]="showSPI">
            </app-tool-insertion-cycles-form>
        </ng-template>
    </app-wizard-step>
</app-wizard-modal>
<app-tool-property-validation-info-modal
    #infoModal
    [title]="'validation.toolCode.infoModal.title' | translate"
    [message]="'validation.toolCode.infoModal.message' | translate"
    [tools]="infoModalTools"
    (confirm)="onInfoConfirm()">
</app-tool-property-validation-info-modal>
